import t, { useState as r, useEffect as l } from "react";
import { useAtomValue as N } from "jotai";
import $ from "./index79.mjs";
import { Header as j } from "./index97.mjs";
import p from "./index98.mjs";
import { useExtras as q } from "./index99.mjs";
import { useHandleNextStep as J } from "./index100.mjs";
import { useHotelConfig as Q } from "./index93.mjs";
import { useRemoveCart as X } from "./index101.mjs";
import { useSalesTermsShow as Z, useTermsAndConditionsShow as ee, useSalesTermsAndConditions as te } from "./index102.mjs";
import "@amenitiz/design-system";
import { cartItemsAtom as oe, giftCardsAtom as se } from "./index34.mjs";
import { getTitle as ne } from "./index103.mjs";
import { SingleRoomStep as re } from "./index104.mjs";
import { RoomWithExtrasStep as ae } from "./index105.mjs";
import { ClientDetailsStep as h } from "./index106.mjs";
import { PaymentStep as g } from "./index107.mjs";
import { track as ie } from "./index9.mjs";
import { TRACK_EVENT_TYPE as me, TRACK_EVENT as le } from "./index10.mjs";
import { TermsAndConditions as w } from "./index108.mjs";
import { Loader as ce } from "./index11.mjs";
import { useCheckout as pe } from "./index109.mjs";
import { getSubscriptionPlanRoot as de } from "./index14.mjs";
import ue from "classnames";
const Ge = ({ onClose: L }) => {
  const [s, C] = r(1), [a, d] = r([]), [M, E] = r(!1), [u, S] = r(null), e = N(oe), y = N(se), { setCurrentStep: T, setSummaryButton: f, allocateGuests: k } = pe(), c = s - 1, v = s <= a.length - 2 && e.length > 1 && c != e.length - 1, { removeCartItem: _ } = X(), { setShowSalesTerms: A, isShowSalesTerms: P } = Z(), { setShowTermsAndConditions: x, isShowTermsAndConditions: H } = ee(), { salesTermsAndConditions: i } = te(), { addMandatoryExtrasToCart: K } = q(), [I, F] = r(), [m, G] = r(!1), { hotelId: V, propertySize: z, propertyType: B, subscriptionPlan: D } = Q(), O = () => {
    L(), T(1);
  };
  l(() => {
    if (e.length) {
      if (e.length === 1 && !m) {
        const {
          id: o,
          totalAdults: n,
          maxAdults: W,
          totalChildren: R,
          maxOccupancy: Y,
          maxChildren: b
        } = e[0];
        k({
          cartItemId: o,
          personType: "totalAdults",
          amount: Math.min(n, W)
        }), k({
          cartItemId: o,
          personType: "totalChildren",
          amount: Math.min(
            R,
            b === null ? Math.max(Y - n, 0) : Math.min(R, b)
          )
        }), G(!0);
        return;
      }
      e.length === 1 && m && (E(!0), $.getExtrasPerRoom(e[0]).then(({ data: o }) => {
        const { optional_extras: n = [] } = o;
        S(n.length > 0), F(o), K(o, e[0].id);
      }).catch(() => {
        S(!1);
      }).finally(() => {
        E(!1);
      }));
    }
  }, [m, e.length]), l(() => {
    f({
      label: I18n.t("booking_engine.information.continue")
    });
  }, [v, f]), J(() => (C(s + 1), s === a.length)), l(() => {
    y.length && d([
      /* @__PURE__ */ t.createElement(h, { key: "details-step" }),
      /* @__PURE__ */ t.createElement(g, { key: "payment-step" })
    ]);
  }, [y.length]), l(() => {
    if (e.length && !(e.length === 1 && u === null)) {
      if (e.length === 1 && u === !1 && m) {
        d([
          /* @__PURE__ */ t.createElement(h, { key: "details-step" }),
          /* @__PURE__ */ t.createElement(g, { key: "payment-step" })
        ]);
        return;
      }
      d([
        ...e.map(
          (o, n) => e.length === 1 ? /* @__PURE__ */ t.createElement(
            re,
            {
              key: "single-room-step",
              cartItem: o,
              preFetchedExtras: I
            }
          ) : /* @__PURE__ */ t.createElement(
            ae,
            {
              key: o.id,
              isFirst: n === 0,
              cartItem: o,
              removeRoom: _
            }
          )
        ),
        /* @__PURE__ */ t.createElement(h, { key: "details-step" }),
        /* @__PURE__ */ t.createElement(g, { key: "payment-step" })
      ]);
    }
  }, [
    m,
    u,
    I,
    e,
    _
  ]), l(() => {
    A(!1), x(!1);
  }, [A, x]);
  const U = () => {
    ie(le.CLICK, me.RETURN_CLICKED, {
      hotel_id: V,
      property_type: B,
      property_size: z,
      subscription_plan: de(D)
    }), s > 1 ? C(s - 1) : (T(1), f({
      label: I18n.t("booking_engine.information.continue"),
      disabled: !1
    }));
  };
  return P && i ? /* @__PURE__ */ t.createElement(
    w,
    {
      salesTerms: i.sales_terms,
      checkoutStep: !0
    }
  ) : H && i ? /* @__PURE__ */ t.createElement(
    w,
    {
      salesTerms: i.sales_terms,
      title: I18n.t("booking_engine.information.terms_and_conditions"),
      checkoutStep: !0,
      termsAndConditions: i.terms_and_conditions
    }
  ) : M ? /* @__PURE__ */ t.createElement("div", { className: ue(p.container, p.loader) }, /* @__PURE__ */ t.createElement(ce, null)) : /* @__PURE__ */ t.createElement("div", { className: p.container }, /* @__PURE__ */ t.createElement(
    j,
    {
      onClose: O,
      title: ne(s, a.length),
      stepsLength: a.length,
      currentIndex: c,
      onClickBack: U
    }
  ), /* @__PURE__ */ t.createElement(
    "div",
    {
      "data-testid": `step-component-${c}`,
      className: p.body
    },
    a[c]
  ));
};
export {
  Ge as Checkout
};
